<template>
  <message-box
    v-if="displayCreateTaskMsgBox.display"
    :title="
      displayCreateTaskMsgBox.type === 'edit' ? 'Edit task' : 'Create task'
    "
    type="default"
    :submit-text="
      displayCreateTaskMsgBox.type === 'edit' ? 'Update task' : 'Create task'
    "
    :disable-submit="disableTaskSubmitBtn"
    @on-close="handleCloseTask"
    @on-submit="handleSubmitTask"
    @on-cancel="handleCancelMessage"
  >
    <div class="message-contents-field">
      <NrSelect
        placeholder="Select a user to assign task"
        v-model="selectedCreateTaskAssignee"
        :options="requestStaffList"
      >
        <template v-slot:label> User </template>
      </NrSelect>

      <NrDatePicker
        v-model="taskDueDate"
        :calendarStyles="{ position: 'absolute', zIndex: 1 }"
      >
        <template v-slot:label>Due date</template>
        <template v-slot:trigger><NrIcon name="calendar-alt" /></template>
      </NrDatePicker>
      <NrFormLabel>Message contents</NrFormLabel>
      <nr-editor
        v-model="taskMsg"
        :resizable="false"
        :rows="12"
        strike
        orderedList
        bulletList
        link
        placeholder="Enter your task description here"
      />
    </div>
  </message-box>
</template>

<script lang="ts">
import MessageBox from '@nextrequestco/components/src/components/MessageBox'
import NrEditor from '@nextrequestco/components/src/components/NrEditor'
import humanFriendlyDateTime from '../../../../mixins/humanFriendlyDateTime'
import { mapActions, mapState } from 'vuex'
import NrSelect from '@nextrequestco/components/src/components/NrSelect'
import NrDatePicker from '@nextrequestco/components/src/components/NrDatePicker'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/'

export default {
  name: 'TaskModal',
  components: {
    NrFormLabel,
    MessageBox,
    'nr-editor': NrEditor,
    NrSelect,
    NrDatePicker,
    NrIcon
  },
  mixins: [humanFriendlyDateTime],
  created() {
    if (this.$ability.can('read', 'staff_only_items')) {
      this.fetchInvoiceTemplates(this.request.id)
    }
  },
  watch: {
    displayCreateTaskMsgBox(val) {
      if (val.type === 'new') {
        this.taskMsg = ''
        this.taskDueDate = ''
        this.selectedCreateTaskAssignee = null
      }
      if (val.type === 'edit') {
        this.taskDueDate = this.humanFriendlyDate(
          new Date(this.editingTask.due_date)
        )
        this.taskMsg = this.editingTask.description
        this.selectedCreateTaskAssignee = {
          value: this.editingTask.user.id,
          label: this.editingTask.user.name_with_email,
          user_id: this.editingTask.user.id
        }
      }
    }
  },
  data() {
    return {
      selectedCreateTaskAssignee: {},
      taskMsg: '',
      taskDueDate: ''
    }
  },
  computed: {
    ...mapState('request_show', [
      'requestStaff',
      'currentAction',
      'displayCreateTaskMsgBox',
      'editingTask',
      'request'
    ]),

    disableTaskSubmitBtn() {
      return !(
        this.selectedCreateTaskAssignee &&
        Object.keys(this.selectedCreateTaskAssignee).length &&
        this.taskDueDate &&
        this.taskMsg.length
      )
    },

    requestStaffList() {
      return this.requestStaff
        .map((item) => {
          return {
            id: item.id,
            label: item.name_with_email
          }
        })
        .concat([
          { id: this.request.poc.id, label: this.request.poc.name_with_email }
        ])
    }
  },

  methods: {
    ...mapActions('request_show', [
      'submitNewTask',
      'fetchInvoiceTemplates',
      'setDisplayCreateTaskMsgBox'
    ]),

    handleCancelMessage() {
      this.taskMsg = ''
      this.taskDueDate = null
      this.selectedCreateTaskAssignee = {}
      this.setDisplayCreateTaskMsgBox({ display: false, type: 'new' })
    },

    handleCloseTask() {
      this.setDisplayCreateTaskMsgBox({ display: false })
    },

    handleSubmitTask() {
      this.submitNewTask({
        action_type: this.displayCreateTaskMsgBox.type,
        description: this.taskMsg,
        due_date: this.humanFriendlyDate(this.taskDueDate),
        request_id: this.request.pretty_id,
        task_id: this.editingTask.id,
        user_id:
          this.selectedCreateTaskAssignee.user_id ||
          this.selectedCreateTaskAssignee.id
      })
    }
  }
}
</script>

<style lang="scss">
@import '@nextrequestco/components/src/styles/colors.scss';
.message-box {
  .message-contents-field,
  .editor-field {
    display: flex;
    flex-direction: column;
    flex: 0 1 100%;
  }

  .nr-editor {
    flex: 1 1 auto;
  }

  .nr-datepicker-calendar {
    .nr-datepicker-calendar-header__button {
      border: none;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .nr-datepicker-calendar-dates .button {
      border-width: inherit;
      padding: inherit;
    }
    .table td,
    .table th {
      padding: inherit;
      border: inherit;
    }
  }
}
</style>
